import React from "react";

interface DeleteModalProps {
  onSubmit: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ onSubmit, onCancel, loading }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <h3 className="text-lg font-semibold mb-4">Are you sure you want to delete?</h3>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;